export const environment = {
  production: true,
  openIdUrl: 'https://home.esaote.com',
  applicationEnum: 0, //identificativo di ems gateway su open ID connector
  openIdlogoutUrl: "/MicrosoftIdentity/Account/SignOut",
  arcadocBaseUrl: "https://arcadoc.esaote.com",
  baseUrl: "https://eportal.esaote.com/"
};
